import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _actions, _mutations;
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import axios from 'axios';
import { API_GET_SHOP_DETAIL, API_GET_GROUPS, API_GET_PRODUCTS_IN_SHOP } from '@/apis';
import { GET_SHOP_DETAIL, GET_GROUPS, GET_PRODUCTS_IN_SHOP, TOGGLE_POPUP, RESET_VENUE_DETAIL, MUTATE_SHOP_DETAIL, MUTATE_PRODUCTS_IN_SHOP, MUTATE_PAGING_IN_SHOP, MUTATE_PAGE_LOADING_IN_SHOP, MUTATE_PAGE_NUMBER, MUTATE_GROUPS, MUTATE_POPUP_STATUS, GETTER_SHOP_BASIC, GETTER_SHOP_PRODUCTS, GETTER_SHOP_PAGING, GETTER_SHOP_GROUPS, GETTER_SHOP_PHONES, GETTER_SHOP_SHOWPOPUP } from '@/constants/venue-detail';
function getDefaultShopDetail() {
  return {
    basic: {
      shopName: '',
      shopRegion: '',
      shopCategory: '',
      address: '',
      power: null,
      phones: []
    },
    paging: {
      pageNo: 1,
      pageSize: 10,
      totalHits: null,
      hasMore: true,
      loading: false
    },
    products: [],
    groups: [],
    showPopup: false
  };
}
export default {
  state: getDefaultShopDetail(),
  actions: (_actions = {}, _defineProperty(_actions, GET_SHOP_DETAIL, function (_ref, shopId) {
    var commit = _ref.commit,
      state = _ref.state;
    axios.get(API_GET_SHOP_DETAIL(shopId)).then(function (_ref2) {
      var code = _ref2.code,
        data = _ref2.data;
      if (code === 200) {
        commit(MUTATE_SHOP_DETAIL, Object.assign({}, data, {
          shopId: shopId
        }));
      }
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, GET_GROUPS, function (_ref3, shopId) {
    var commit = _ref3.commit,
      state = _ref3.state;
    var _state$paging = state.paging,
      pageNo = _state$paging.pageNo,
      pageSize = _state$paging.pageSize;
    axios.get(API_GET_GROUPS({
      shopId: shopId,
      pageNo: pageNo,
      pageSize: pageSize
    })).then(function (_ref4) {
      var code = _ref4.code,
        data = _ref4.data;
      if (code === 200) {
        commit(MUTATE_GROUPS, data);
      }
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, TOGGLE_POPUP, function (_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    commit(MUTATE_POPUP_STATUS, !state.showPopup);
  }), _defineProperty(_actions, RESET_VENUE_DETAIL, function (_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state;
    var _getDefaultShopDetail = getDefaultShopDetail(),
      basic = _getDefaultShopDetail.basic,
      paging = _getDefaultShopDetail.paging,
      products = _getDefaultShopDetail.products;
    commit(MUTATE_SHOP_DETAIL, basic);
    commit(MUTATE_PAGING_IN_SHOP, paging);
    commit(MUTATE_PRODUCTS_IN_SHOP, {
      products: products
    });
  }), _defineProperty(_actions, GET_PRODUCTS_IN_SHOP, function (_ref7, params) {
    var commit = _ref7.commit,
      state = _ref7.state;
    commit(MUTATE_PAGE_LOADING_IN_SHOP);
    axios.get(API_GET_PRODUCTS_IN_SHOP(params)).then(function (_ref8) {
      var code = _ref8.code,
        products = _ref8.data,
        paging = _ref8.paging;
      if (code === 200) {
        commit(MUTATE_PRODUCTS_IN_SHOP, {
          products: products,
          isConcat: params.pageNo !== state.paging.pageNo
        });
        commit(MUTATE_PAGING_IN_SHOP, paging);
      }
      commit(MUTATE_PAGE_LOADING_IN_SHOP);
    }).catch(function (err) {
      console.warn(err);
    });
  }), _actions),
  mutations: (_mutations = {}, _defineProperty(_mutations, MUTATE_SHOP_DETAIL, function (state, basic) {
    state.basic = basic;
  }), _defineProperty(_mutations, MUTATE_GROUPS, function (state, groups) {
    state.groups = groups;
  }), _defineProperty(_mutations, MUTATE_PRODUCTS_IN_SHOP, function (state, _ref9) {
    var products = _ref9.products,
      isConcat = _ref9.isConcat;
    state.products = isConcat ? state.products.concat(products) : products;
  }), _defineProperty(_mutations, MUTATE_PAGING_IN_SHOP, function (state, paging) {
    state.paging = Object.assign({}, state.paging, paging);
  }), _defineProperty(_mutations, MUTATE_PAGE_LOADING_IN_SHOP, function (state, paging) {
    state.paging.loading = !state.paging.loading;
  }), _defineProperty(_mutations, MUTATE_PAGE_NUMBER, function (state, pageNo) {
    state.paging.pageNo = pageNo;
  }), _defineProperty(_mutations, MUTATE_POPUP_STATUS, function (state, showPopup) {
    state.showPopup = showPopup;
  }), _mutations),
  getters: {
    GETTER_SHOP_BASIC: function GETTER_SHOP_BASIC(state) {
      return state.basic;
    },
    GETTER_SHOP_PRODUCTS: function GETTER_SHOP_PRODUCTS(state) {
      return state.products;
    },
    GETTER_SHOP_PAGING: function GETTER_SHOP_PAGING(state) {
      return state.paging;
    },
    GETTER_SHOP_GROUPS: function GETTER_SHOP_GROUPS(state) {
      return state.groups;
    },
    GETTER_SHOP_PHONES: function GETTER_SHOP_PHONES(state) {
      return state.basic.phones;
    },
    GETTER_SHOP_SHOWPOPUP: function GETTER_SHOP_SHOWPOPUP(state) {
      return state.showPopup;
    }
  }
};